import { memo } from 'react';

type SortingIconProps = { colorUp: string; colorDown: string };

const SortingIconView: React.FC<SortingIconProps> = ({
  colorUp,
  colorDown,
}) => (
  <svg
    width="12"
    height="24"
    viewBox="0 0 12 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 8.5L6 3.5L11 8.5H1Z" fill={colorUp} />
    <path d="M6 20.5L1 15.5H11L6 20.5Z" fill={colorDown} />
  </svg>
);

export const SortingIcon = memo(SortingIconView);
export default SortingIcon;
